export const GET_NEWS_EVENTS = 'GET_NEWS_EVENTS';
